import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

const TinyLabel = styled(Typography)(({ theme }) => ({
    textAlign: 'left',
    fontSize: 12,
    width: '100%',
    paddingLeft: 16,
    color: theme.palette.text.primary
}));


export default TinyLabel;